<template>
  <div v-if="show">
    <LineChartGenerator :chart-options="chartOptions" :chart-data="chartDataUser" :chart-id="chartId"
      :dataset-id-key="datasetIdKey" :plugins="plugins" :css-classes="cssClasses" :styles="styles" :width="width"
      :height="height" />
    <LineChartGenerator :chart-options="chartOptions" :chart-data="chartDataTask" :chart-id="chartId"
      :dataset-id-key="datasetIdKey" :plugins="plugins" :css-classes="cssClasses" :styles="styles" :width="width"
      :height="height" />

    <LineChartGenerator :chart-options="chartOptions" :chart-data="chartDataJob" :chart-id="chartId"
      :dataset-id-key="datasetIdKey" :plugins="plugins" :css-classes="cssClasses" :styles="styles" :width="width"
      :height="height" />

    <LineChartGenerator :chart-options="chartOptions" :chart-data="chartDataUserNew" :chart-id="chartId"
      :dataset-id-key="datasetIdKey" :plugins="plugins" :css-classes="cssClasses" :styles="styles" :width="width"
      :height="height" />

    <LineChartGenerator :chart-options="chartOptions" :chart-data="chartDataUserOnline" :chart-id="chartId"
      :dataset-id-key="datasetIdKey" :plugins="plugins" :css-classes="cssClasses" :styles="styles" :width="width"
      :height="height" />

    <LineChartGenerator :chart-options="chartOptions" :chart-data="chartDataBalance" :chart-id="chartId"
      :dataset-id-key="datasetIdKey" :plugins="plugins" :css-classes="cssClasses" :styles="styles" :width="width"
      :height="height" />

    <LineChartGenerator :chart-options="chartOptions" :chart-data="chartDataPayins" :chart-id="chartId"
      :dataset-id-key="datasetIdKey" :plugins="plugins" :css-classes="cssClasses" :styles="styles" :width="width"
      :height="height" />
  </div>
</template>

<script>
import {Line as LineChartGenerator} from 'vue-chartjs/legacy'
import HTTP from "../http";
import {show_error} from "../message";


import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)

export default {
  name: 'LineChart',
  components: {
    LineChartGenerator
  },
  props: {
    chartId: {
      type: String,
      default: 'line-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => { }
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      data: {},
      show: false,
      chartDataUser: {
        labels: [],
        datasets: [
          {
            label: 'Users',
            backgroundColor: '#f87979',
            data: [],
            borderColor: '#f87979',
          }
        ]
      },
      chartDataTask: {
        labels: [],
        datasets: [
          {
            label: 'Task',
            backgroundColor: '#00FF00',
            data: [],
            borderColor: '#00FF00',
          }
        ]
      },
      chartDataJob: {
        labels: [],
        datasets: [
          {
            label: 'Job',
            backgroundColor: '#0000FF',
            data: [],
            borderColor: '#0000FF',
          }
        ]
      },
      chartDataUserNew: {
        labels: [],
        datasets: [
          {
            label: 'User new',
            backgroundColor: '#00FF00',
            data: [],
            borderColor: '#00FF00',
          }
        ]
      },
      chartDataUserOnline: {
        labels: [],
        datasets: [
          {
            label: 'User per day',
            backgroundColor: '#0000FF',
            data: [],
            borderColor: '#0000FF',
          }
        ]
      },
      chartDataBalance: {
        labels: [],
        datasets: [
          {
            label: 'Balance',
            backgroundColor: '#00FF00',
            data: [],
            borderColor: '#00FF00',
          }
        ]
      },
      chartDataPayins: {
        labels: [],
        datasets: [
          {
            label: 'Payin',
            backgroundColor: '#0000FF',
            data: [],
            borderColor: '#0000FF',
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  created() {
    this.fetchData();
  },
  computed: {
    chartDataCom: function () {
      return this.chartData;
    }
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .get("admin/stat")
        .then((resp) => {
          console.log('resp', resp)
          this.chartDataUser.labels = resp.data.map(x => x.created_at)
          this.chartDataUser.datasets[0].data = resp.data.map(x => x.users)

          let tasks = resp.data.map(x => x.tasks);
          tasks = tasks.slice(1).map((v, i) => v - tasks[i]);

          this.chartDataTask.labels = resp.data.map(x => x.created_at)
          this.chartDataTask.datasets[0].data = tasks

          let jobs = resp.data.map(x => x.jobs);
          jobs = jobs.slice(1).map((v, i) => v - jobs[i]);

          this.chartDataJob.labels = resp.data.map(x => x.created_at)
          this.chartDataJob.datasets[0].data = jobs

          this.chartDataUserNew.labels = resp.data.filter(x => x.users_new > 0).map(x => x.created_at)
          this.chartDataUserNew.datasets[0].data = resp.data.filter(x => x.users_new > 0).map(x => x.users_new)

          this.chartDataUserOnline.labels = resp.data.filter(x => x.users_day > 0).map(x => x.created_at)
          this.chartDataUserOnline.datasets[0].data = resp.data.filter(x => x.users_day > 0).map(x => x.users_day)


          this.chartDataBalance.labels = resp.data.filter(x => x.balance > 0 && x.balance < 360000).map(x => x.created_at)
          this.chartDataBalance.datasets[0].data = resp.data.filter(x => x.balance > 0 && x.balance < 360000).map(x => x.balance)

          this.chartDataPayins.labels = resp.data.filter(x => x.payins > 0).map(x => x.created_at)
          this.chartDataPayins.datasets[0].data = resp.data.filter(x => x.payins > 0).map(x => x.payins)

          this.show = true
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },
  },
}
</script>
